<template>
  <div class="row">
    <div class="align-stepper-center">
      <div class="wrapper-progressBar">
        <Tooltip :text="tooltipText" :enterable="false">
          <ul class="progressBar" role="list" aria-label="progress steps" data-test="progress-bar">
            <li
              v-for="index in stepsCount"
              :key="index"
              :class="getStepperClass(index - 1)"
              :data-test="`progress-bar-step-${index}`"
            ></li>
          </ul>
        </Tooltip>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Tooltip } from "uiv";
import { computed } from "vue";

const props = defineProps<{ completedStep: number; stepsCount: number; showTooltip: boolean }>();

const getStepperClass = (index: number): string => {
  if (props.completedStep + 1 === index) return "active";
  if (props.completedStep < index) return "";
  return "completed";
};

const tooltipText = computed<string>(() => {
  return props.showTooltip && props.completedStep + 1 !== props.stepsCount
    ? `Step ${props.completedStep + 2} out of ${props.stepsCount}`
    : "";
});
</script>

<style lang="less">
@import (reference) "../../styles/bootstrap/variables.less";
@import (reference) "../../styles/bootstrap/glyphicons.less";

.align-stepper-center {
  display: flex;
  justify-items: center;
  align-items: center;
  height: 50px;
}

.wrapper-progressBar {
  width: 20%;
  min-width: 100px;
  margin: 4rem auto;

  @media (max-width: @screen-sm) {
    width: 40%;
  }
}

.progressBar {
  padding-inline-start: 0;
  display: flex;
}

.progressBar li {
  list-style-type: none;
  float: left;
  flex: 1;
  position: relative;
  text-align: center;
}

.progressBar li:before {
  content: " ";
  line-height: 30px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 2px solid #ddd;
  display: block;
  text-align: center;
  margin: 0 auto 10px;
  background-color: white;
  position: relative;
  z-index: 1;
}

.progressBar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #ddd;
  top: 15px;
  left: -50%;
}

.progressBar li:first-child:after {
  content: none;
}

.progressBar li.active {
  color: @charismatic-color;
}

.progressBar li.active:before {
  border-color: @charismatic-color;
  background-color: #fff;
}

.progressBar .active:after,
.progressBar .completed:after {
  background-color: @charismatic-color;
}

.progressBar li.completed:before {
  background-color: @charismatic-color;
  background-image: url("../../assets/button-icons/tick-icon-white.svg");
  background-size: 20px 20px;
  background-position: 3px center;
  background-repeat: no-repeat;
  border-color: @charismatic-color;
}
</style>
